import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { 
  ChevronLeft, Calendar, MapPin, Users, Play, Image, X, 
  Clock, CheckCircle, Circle, Eye, Sparkles, Heart
} from "lucide-react";
import { Button } from "../components/ui/button";

// 모든 이벤트 (날짜순 정렬을 위해 dateSort 추가)
const allEvents = [
  // 예정된 이벤트
  {
    id: 103,
    title: "Summer Yacht Party",
    date: "2026년 7월 19일",
    dateSort: "2026-07-19",
    time: "17:00 - 21:00",
    location: "한강 요트 선착장",
    attendees: 0,
    maxAttendees: 20,
    price: 180000,
    status: "upcoming",
    description: "한강 위에서 펼쳐지는 요트 파티. 선셋과 함께하는 낭만적인 크루즈 파티입니다.",
    poster: "https://static.prod-images.emergentagent.com/jobs/62e113a6-fe02-48dd-a8bb-4b26ed6daf98/images/99669bea05b64305e1dec94d907e68333aff39d4f3ab45dfdaff4e1ff1d426d2.png",
    invitation: `당신을 한강 위 로맨틱한 요트 파티에 초대합니다.

서울의 아름다운 스카이라인을 배경으로 선셋과 함께하는 특별한 저녁,
샴페인 한 잔과 함께 새로운 인연을 만나보세요.

프리미엄 요트에서 펼쳐지는 이 특별한 밤,
당신의 소중한 인연이 기다리고 있습니다.

✨ 프로그램 안내
• 17:00 - 승선 및 웰컴 드링크
• 17:30 - 출항 및 아이스브레이킹
• 18:30 - 선셋 디너 & 와인 페어링
• 20:00 - 프리 미팅 타임
• 21:00 - 귀항

🎁 포함 사항
• 프리미엄 요트 크루즈
• 코스 디너 & 와인
• 프로페셔널 호스팅`,
    media: []
  },
  {
    id: 102,
    title: "Art Gallery 와인 나이트",
    date: "2026년 5월 8일",
    dateSort: "2026-05-08",
    time: "19:00 - 22:00",
    location: "서울 삼청동 갤러리",
    attendees: 0,
    maxAttendees: 24,
    price: 120000,
    status: "upcoming",
    description: "현대 미술 전시와 함께하는 와인 나이트. 예술과 로맨스가 어우러지는 특별한 저녁을 경험하세요.",
    poster: "https://static.prod-images.emergentagent.com/jobs/62e113a6-fe02-48dd-a8bb-4b26ed6daf98/images/537b50e9500f474838d1bd2da7758cde015a842ce1c9878e27f308892dff6586.png",
    invitation: `예술과 와인, 그리고 설렘이 만나는 밤

삼청동의 감각적인 갤러리에서
현대 미술 작품과 함께하는 특별한 와인 나이트에 초대합니다.

소믈리에가 엄선한 프리미엄 와인과 함께
예술에 대한 이야기를 나누며 자연스럽게 다가오는 인연.

당신의 취향과 감성이 통하는 특별한 누군가를 만나보세요.

✨ 프로그램 안내
• 19:00 - 리셉션 및 웰컴 와인
• 19:30 - 큐레이터와 함께하는 갤러리 투어
• 20:30 - 와인 테이스팅 & 프리 토크
• 21:30 - 디저트 & 네트워킹

🎁 포함 사항
• 프리미엄 와인 4종 테이스팅
• 핑거푸드 & 디저트
• 전시 입장권`,
    media: []
  },
  {
    id: 101,
    title: "Spring Garden Party",
    date: "2026년 4월 12일",
    dateSort: "2026-04-12",
    time: "12:00 - 16:00",
    location: "서울 한남동 가든 레스토랑",
    attendees: 0,
    maxAttendees: 30,
    price: 95000,
    status: "upcoming",
    description: "봄꽃이 만발한 정원에서 진행되는 가든 파티. 브런치와 함께하는 우아한 만남의 시간을 준비했습니다.",
    poster: "https://static.prod-images.emergentagent.com/jobs/62e113a6-fe02-48dd-a8bb-4b26ed6daf98/images/a7ef07f13cfcd8c453e65120affb7ed363da216d31b63770d4b04b111040415a.png",
    invitation: `봄꽃이 만발한 정원에서의 특별한 만남

한남동의 아름다운 가든 레스토랑에서
봄의 설렘을 함께 나눌 분을 초대합니다.

화창한 봄 햇살 아래, 우아한 브런치와 함께
자연스럽고 편안한 대화를 나눠보세요.

새로운 계절, 새로운 인연의 시작을 리즈와 함께하세요.

✨ 프로그램 안내
• 12:00 - 가든 리셉션 & 웰컴 드링크
• 12:30 - 브런치 코스 시작
• 14:00 - 가든 산책 & 1:1 미니 토크
• 15:00 - 디저트 & 프리 미팅
• 16:00 - 클로징

🎁 포함 사항
• 시그니처 브런치 풀코스
• 웰컴 드링크 & 디저트
• 전문 호스트 진행`,
    media: []
  },
  // 과거 이벤트
  {
    id: 1,
    title: "Valentine 2026 와인 파티",
    date: "2026년 2월 14일",
    dateSort: "2026-02-14",
    time: "19:00 - 22:00",
    location: "서울 청담동 와인바",
    attendees: 24,
    price: 150000,
    status: "completed",
    description: "발렌타인 데이를 맞아 진행된 프리미엄 와인 파티. 소믈리에와 함께하는 와인 테이스팅과 함께 로맨틱한 만남의 시간을 가졌습니다.",
    poster: "",
    invitation: "",
    media: [
      { type: "video", url: "https://customer-assets.emergentagent.com/job_c31d3ebc-0781-4769-9553-55de188c1b77/artifacts/y3pmkx9h_%5Bvalentine%202026%5D%EC%8A%A4%EC%BC%80%EC%B9%98%EC%98%81%EC%83%81%28%EB%B0%B0%EA%B2%BD%EC%9D%8C%EC%95%85%20%EA%B5%90%EC%B2%B4%29.mp4", title: "Valentine 2026 스케치 영상" },
    ]
  },
  {
    id: 2,
    title: "2026 신년 갈라 디너",
    date: "2026년 1월 18일",
    dateSort: "2026-01-18",
    time: "18:00 - 22:00",
    location: "서울 강남 호텔 그랜드볼룸",
    attendees: 40,
    price: 200000,
    status: "completed",
    description: "새해를 맞아 진행된 격조 높은 갈라 디너. 라이브 재즈 공연과 함께 품격 있는 만남의 시간을 가졌습니다.",
    poster: "",
    invitation: "",
    media: []
  },
  {
    id: 3,
    title: "크리스마스 이브 파티",
    date: "2025년 12월 24일",
    dateSort: "2025-12-24",
    time: "19:00 - 23:00",
    location: "서울 이태원 루프탑 라운지",
    attendees: 32,
    price: 130000,
    status: "completed",
    description: "크리스마스 이브에 진행된 특별한 파티. 야경과 함께하는 로맨틱한 분위기 속에서 새로운 인연을 만났습니다.",
    poster: "",
    invitation: "",
    media: []
  },
].sort((a, b) => new Date(b.dateSort) - new Date(a.dateSort)); // 최신순 정렬

export const OfflineEventsPage = () => {
  const [selectedMedia, setSelectedMedia] = useState(null);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const navigate = useNavigate();

  const handleApply = (event) => {
    navigate(`/event-payment/${event.id}`, { state: { event } });
  };

  return (
    <div className="min-h-screen bg-[#FAFAF9] pt-20">
      {/* Hero Section */}
      <div 
        className="relative py-16 lg:py-24 overflow-hidden"
        style={{ backgroundImage: "url('/images/offline-event-bg.png')", backgroundSize: 'cover', backgroundPosition: 'center' }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black/70" />
        <div className="max-w-6xl mx-auto px-6 relative z-10">
          <Link 
            to="/" 
            className="inline-flex items-center gap-2 text-white/80 hover:text-white mb-8 transition-colors"
          >
            <ChevronLeft className="w-5 h-5" />
            홈으로 돌아가기
          </Link>
          
          <div className="text-center">
            <span className="text-gold-400 font-medium text-sm tracking-wider uppercase mb-4 block">
              Offline Event
            </span>
            <h1 className="font-sans text-4xl md:text-5xl lg:text-6xl font-[720] text-white mb-4">
              오프라인 이벤트
            </h1>
            <p className="text-xl md:text-2xl text-gold-300 font-medium mb-4">
              "좋은 인연을 만나는 가장 우아한 방법"
            </p>
            <p className="text-white/80 max-w-2xl mx-auto">
              리즈가 제안하는 프리미엄 오프라인 이벤트에서 특별한 만남을 경험하세요
            </p>
            <p className="text-white/50 text-sm mt-3">모든 날짜·시간은 한국 시간(KST) 기준입니다.</p>
          </div>
        </div>
      </div>

      {/* Events List */}
      <div className="max-w-6xl mx-auto px-6 py-12">
        <div className="space-y-6">
          {allEvents.map((event) => (
            <div 
              key={event.id}
              className={`bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow border-l-4 ${
                event.status === "upcoming" ? "border-l-burgundy-500" : "border-l-stone-300"
              }`}
            >
              <div className="p-6 md:p-8">
                <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-4">
                  {/* Event Info */}
                  <div className="flex-1">
                    <div className="flex items-center gap-2 mb-3">
                      {event.status === "completed" ? (
                        <span className="px-3 py-1 bg-stone-100 text-stone-600 text-xs font-medium rounded-full flex items-center gap-1">
                          <CheckCircle className="w-3 h-3" />
                          완료됨
                        </span>
                      ) : (
                        <span className="px-3 py-1 bg-burgundy-100 text-burgundy-600 text-xs font-medium rounded-full flex items-center gap-1">
                          <Circle className="w-3 h-3 fill-burgundy-500" />
                          예정됨
                        </span>
                      )}
                      <span className="text-stone-400 text-sm">{event.date}</span>
                      {event.eligibility && event.eligibility !== "all" && (
                        <span className="px-3 py-1 bg-burgundy-600 text-white text-xs font-bold rounded-full" data-testid="event-eligibility-badge">
                          {event.eligibility === "vip" ? "VIP 전용" : "정회원 전용"}
                        </span>
                      )}
                    </div>
                    
                    <h3 className="text-xl md:text-2xl font-bold text-stone-800 mb-3">
                      {event.title}
                    </h3>
                    
                    <div className="flex flex-wrap gap-4 text-stone-600 text-sm mb-4">
                      <div className="flex items-center gap-1">
                        <MapPin className="w-4 h-4" />
                        {event.location}
                      </div>
                      <div className="flex items-center gap-1">
                        <Users className="w-4 h-4" />
                        {event.status === "completed" 
                          ? `${event.attendees}명 참석`
                          : `정원 ${event.maxAttendees}명`
                        }
                      </div>
                    </div>
                    
                    <p className="text-stone-600 leading-relaxed">
                      {event.description}
                    </p>
                  </div>

                  {/* Action Buttons */}
                  <div className="flex flex-col gap-2 md:min-w-[160px]">
                    {event.status === "upcoming" ? (
                      <Button 
                        className="btn-primary"
                        onClick={() => setSelectedEvent(event)}
                        data-testid={`event-detail-btn-${event.id}`}
                      >
                        <Eye className="w-4 h-4 mr-2" />
                        자세히 보기
                      </Button>
                    ) : (
                      event.media && event.media.length > 0 && (
                        <Button 
                          variant="outline"
                          className="border-burgundy-500 text-burgundy-500 hover:bg-burgundy-50"
                          onClick={() => setSelectedMedia(event)}
                          data-testid={`event-media-btn-${event.id}`}
                        >
                          {event.media[0].type === "video" ? (
                            <>
                              <Play className="w-4 h-4 mr-2" />
                              미디어 보기
                            </>
                          ) : (
                            <>
                              <Image className="w-4 h-4 mr-2" />
                              미디어 보기
                            </>
                          )}
                        </Button>
                      )
                    )}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Media Modal */}
      {selectedMedia && (
        <div 
          className="fixed inset-0 bg-black/90 flex items-center justify-center z-50 p-4"
          onClick={() => setSelectedMedia(null)}
        >
          <div 
            className="relative max-w-5xl w-full"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Close Button */}
            <button 
              className="absolute -top-12 right-0 text-white hover:text-gold-400 transition-colors"
              onClick={() => setSelectedMedia(null)}
            >
              <X className="w-8 h-8" />
            </button>
            
            {/* Event Title */}
            <h3 className="text-white text-xl font-bold mb-4 text-center">
              {selectedMedia.title}
            </h3>

            {/* Media Content */}
            {selectedMedia.media && selectedMedia.media.length > 0 && (
              <div className="rounded-xl overflow-hidden shadow-2xl">
                {selectedMedia.media[0].type === "video" ? (
                  <video
                    className="w-full aspect-video"
                    controls
                    autoPlay
                  >
                    <source src={selectedMedia.media[0].url} type="video/mp4" />
                    브라우저가 비디오를 지원하지 않습니다.
                  </video>
                ) : (
                  <img 
                    src={selectedMedia.media[0].url} 
                    alt={selectedMedia.media[0].title}
                    className="w-full"
                  />
                )}
              </div>
            )}
            
            {/* Media Caption */}
            {selectedMedia.media && selectedMedia.media.length > 0 && (
              <p className="text-center text-white/70 text-sm mt-4">
                {selectedMedia.media[0].title}
              </p>
            )}
          </div>
        </div>
      )}

      {/* Event Detail Modal */}
      {selectedEvent && (
        <div 
          className="fixed inset-0 bg-black/80 flex items-center justify-center z-50 p-4 overflow-y-auto"
          onClick={() => setSelectedEvent(null)}
        >
          <div 
            className="relative bg-white rounded-2xl max-w-4xl w-full max-h-[90vh] overflow-y-auto my-8"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Close Button */}
            <button 
              className="absolute top-4 right-4 z-10 bg-white/90 rounded-full p-2 shadow-lg hover:bg-white transition-colors"
              onClick={() => setSelectedEvent(null)}
              data-testid="close-event-detail-modal"
            >
              <X className="w-6 h-6 text-stone-600" />
            </button>

            {/* Poster Image */}
            {selectedEvent.poster && (
              <div className="relative">
                <img 
                  src={selectedEvent.poster} 
                  alt={selectedEvent.title}
                  className="w-full h-[400px] object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
                <div className="absolute bottom-6 left-6 right-6">
                  <span className="px-3 py-1 bg-burgundy-500 text-white text-xs font-medium rounded-full mb-3 inline-block">
                    {selectedEvent.status === "upcoming" ? "모집중" : "완료됨"}
                  </span>
                  <h2 className="text-3xl md:text-4xl font-[720] text-white mb-2">
                    {selectedEvent.title}
                  </h2>
                </div>
              </div>
            )}

            {/* Event Details */}
            <div className="p-6 md:p-8">
              {/* Event Info Grid */}
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
                <div className="bg-stone-50 rounded-xl p-4 text-center">
                  <Calendar className="w-5 h-5 text-burgundy-500 mx-auto mb-2" />
                  <p className="text-xs text-stone-500 mb-1">날짜</p>
                  <p className="font-semibold text-stone-800 text-sm">{selectedEvent.date}</p>
                </div>
                <div className="bg-stone-50 rounded-xl p-4 text-center">
                  <Clock className="w-5 h-5 text-burgundy-500 mx-auto mb-2" />
                  <p className="text-xs text-stone-500 mb-1">시간</p>
                  <p className="font-semibold text-stone-800 text-sm">{selectedEvent.time}</p>
                </div>
                <div className="bg-stone-50 rounded-xl p-4 text-center">
                  <MapPin className="w-5 h-5 text-burgundy-500 mx-auto mb-2" />
                  <p className="text-xs text-stone-500 mb-1">장소</p>
                  <p className="font-semibold text-stone-800 text-sm">{selectedEvent.location}</p>
                </div>
                <div className="bg-stone-50 rounded-xl p-4 text-center">
                  <Users className="w-5 h-5 text-burgundy-500 mx-auto mb-2" />
                  <p className="text-xs text-stone-500 mb-1">정원</p>
                  <p className="font-semibold text-stone-800 text-sm">{selectedEvent.maxAttendees}명</p>
                </div>
              </div>

              {/* Invitation Text */}
              <div className="mb-8">
                <div className="flex items-center gap-2 mb-4">
                  <Heart className="w-5 h-5 text-burgundy-500" />
                  <h3 className="text-xl font-bold text-stone-800">초대의 말씀</h3>
                </div>
                <div className="bg-gradient-to-br from-burgundy-50 to-stone-50 rounded-xl p-6 border border-burgundy-100">
                  <p className="text-stone-700 leading-relaxed whitespace-pre-line">
                    {selectedEvent.invitation}
                  </p>
                </div>
              </div>

              {/* Price & Apply Button */}
              <div className="bg-stone-900 rounded-xl p-6 flex flex-col md:flex-row items-center justify-between gap-4">
                <div className="text-center md:text-left">
                  <p className="text-stone-400 text-sm mb-1">참가비</p>
                  <p className="text-3xl font-bold text-white">
                    {selectedEvent.price?.toLocaleString()}
                    <span className="text-lg font-normal text-stone-400 ml-1">원</span>
                  </p>
                </div>
                <div className="flex flex-col sm:flex-row gap-3 w-full md:w-auto">
                  <Button 
                    variant="outline"
                    className="border-white/30 text-white hover:bg-white/10 px-6"
                    onClick={() => setSelectedEvent(null)}
                  >
                    닫기
                  </Button>
                  <Button 
                    className="bg-gradient-to-r from-burgundy-500 to-burgundy-600 hover:from-burgundy-600 hover:to-burgundy-700 text-white px-8 py-3 text-lg font-semibold"
                    onClick={() => handleApply(selectedEvent)}
                    data-testid="apply-event-btn"
                  >
                    <Sparkles className="w-5 h-5 mr-2" />
                    참가 신청하기
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default OfflineEventsPage;
